import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Search, Loader2, MessageSquare } from 'lucide-react';

const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 60000;
  if (diff < 1) return 'now';
  if (diff < 60) return `${Math.floor(diff)}m`;
  if (diff < 1440) return `${Math.floor(diff / 60)}h`;
  return new Date(iso).toLocaleDateString();
};

export const ConversationList = ({ conversations, loading, search, onSearch, selected, onSelect }) => (
  <div className="flex flex-col h-full border-r border-border">
    <div className="p-3 border-b border-border relative">
      <Search className="w-4 h-4 absolute left-6 top-1/2 -translate-y-1/2 text-muted-foreground" />
      <Input
        value={search}
        onChange={(e) => onSearch(e.target.value)}
        placeholder="Search phone, email or name"
        className="pl-9 h-10 rounded-lg"
        data-testid="inbox-search-input"
      />
    </div>
    <div className="flex-1 overflow-y-auto" data-testid="inbox-conversation-list">
      {loading && conversations.length === 0 && (
        <div className="flex justify-center py-10"><Loader2 className="w-5 h-5 animate-spin text-muted-foreground" /></div>
      )}
      {!loading && conversations.length === 0 && (
        <div className="flex flex-col items-center text-center py-12 px-4 text-muted-foreground" data-testid="inbox-empty">
          <MessageSquare className="w-8 h-8 mb-2 opacity-50" />
          <p className="text-sm">No conversations yet</p>
          <p className="text-xs mt-1">Incoming WhatsApp messages will appear here.</p>
        </div>
      )}
      {conversations.map((c) => (
        <button
          key={c.wa_id}
          type="button"
          onClick={() => onSelect(c.wa_id)}
          className={`w-full text-left px-4 py-3 border-b border-border transition-colors ${selected === c.wa_id ? 'bg-muted' : 'hover:bg-muted/50'}`}
          data-testid={`inbox-conversation-${c.wa_id}`}
        >
          <div className="flex items-center justify-between gap-2">
            <p className={`text-sm truncate ${c.unread ? 'font-semibold' : 'font-medium'}`}>{c.contact_name || c.phone}</p>
            <span className="text-xs text-muted-foreground shrink-0">{timeAgo(c.last_ts)}</span>
          </div>
          <p className="text-xs text-muted-foreground truncate">{c.user_email || (c.contact_name ? c.phone : 'Not linked to an account')}</p>
          <div className="flex items-center justify-between gap-2 mt-1">
            <p className="text-xs text-muted-foreground truncate">{c.last_direction === 'out' ? 'You: ' : ''}{c.last_text}</p>
            {c.unread > 0 && (
              <Badge className="bg-green-600 text-white h-5 px-2 text-[10px]" data-testid={`inbox-unread-${c.wa_id}`}>{c.unread}</Badge>
            )}
          </div>
        </button>
      ))}
    </div>
  </div>
);
